export default "__VITE_ASSET__CarPJUMC__"